<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.price.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.price.list.title"></app-i18n>
      </h1>

      <app-price-list-toolbar></app-price-list-toolbar>
      <app-price-list-filter></app-price-list-filter>
      <app-price-list-table></app-price-list-table>
    </div>
  </div>
</template>

<script>
import PriceListFilter from '@modules/price/components/price-list-filter.vue';
import PriceListTable from '@modules/price/components/price-list-table.vue';
import PriceListToolbar from '@modules/price/components/price-list-toolbar.vue';

export default {
  name: 'app-price-list-page',

  components: {
    [PriceListFilter.name]: PriceListFilter,
    [PriceListTable.name]: PriceListTable,
    [PriceListToolbar.name]: PriceListToolbar,
  },
};
</script>

<style>
</style>
